import React from 'react';
import { ChevronDown } from 'lucide-react';
export function ScrollIndicator() {
  const handleClick = () => {
    const target = document.getElementById('brand-story');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div onClick={handleClick} className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center animate-bounce-gentle cursor-pointer opacity-80 hover:opacity-100 transition-opacity" data-id="element-146">
      <span className="text-white text-sm uppercase tracking-[0.2em] mb-3 font-light font-optima" data-id="element-147">
        Scroll
      </span>
      <ChevronDown className="w-8 h-8 text-white stroke-[1.5]" data-id="element-148" />
    </div>;
}